module.exports = __webpack_public_path__ + "img/discord-username.a122e7ec.svg";